<template>
  <div>
    <!--跟进主界面开始-->
    <div>
      <van-nav-bar title="客户跟进" left-text="返回" right-text="保存" left-arrow @click-left="onClickLeft"
        @click-right="onClickRight" fixed />
      <!--跟进信息-->
      <div style="margin-top: 45px;">
        <h2 class="van-doc-demo-block__title">跟进信息</h2>
        <van-cell-group>
          <van-field v-model="info.mobile" label="手机号" placeholder="请输入客户手机号" disabled>
            <van-button slot="button" size="small" style="background-color: #4b0;color:#fff;"
              v-on:click="setPhone">电话</van-button>
            <van-button slot="button" size="small" style="background-color: #38f;color:#fff;"
              v-on:click="setMsn">短信</van-button>
          </van-field>
          <van-field v-model="info.name" label="客户姓名" icon="clear" placeholder="请输入客户姓名" @click-icon="info.name = ''"
            required />
          <van-field v-model="info.subject_text" label="主推项目" placeholder="请选择主推项目" v-on:focus="showSubject" required />
          <van-field v-model="log_time" label="约访时间" placeholder="系统默认设置3天后约访" readonly v-on:focus="showLogTime"
            required />
          <van-field v-model="info.come_time" label="预计来访" placeholder="预计来访" v-on:focus="showComeTime">
            <van-button slot="button" size="small" style="background-color: #4b0;color:#fff;"
              v-on:click="cancelComeTime">撤销</van-button>
          </van-field>
          <van-field v-model="info.subjects_text" label="意向项目" placeholder="请选择意向项目" v-on:focus="showSubjectArray" />
          <van-field v-model="log_content" required label="跟进信息" type="textarea" placeholder="请输入跟进信息" rows="2" autosize
            icon="clear" @click-icon="log_content = ''" />
          <van-field v-model="info.keyword" label="关键词" placeholder="请输入客户关键词" icon="clear"
            @click-icon="info.keyword = ''" required />

          <div class="van-cell van-field van-hairline van-cell--required">
            <div class="van-cell__title">
              <span class="van-cell__text">{{ options.status?options.status.name:'' }}</span>
            </div>
            <div class="van-cell__value" style="text-align: left;">
              <div v-if="info.status!==4">
                <label :for="'status'+item.key" v-for="item in options.status?options.status.list:[]" :key="item.key">
                  <van-tag :type="info.status === item.key ? 'success' : '' "
                    class="radio-tag">{{ item.value }}</van-tag>
                  <input type="radio" v-model="info.status" :id="'status'+item.key" :value="item.key"
                    style="display: none" />
                </label>

                <label for="status2" v-if="info.status===2 && options.status && !options.status.list[3]">
                  <van-tag :type="info.status === 2 ? 'success' : '' " class="radio-tag">成交</van-tag>
                  <input type="radio" v-model="info.status" id="status2" value="2" style="display: none" />
                </label>
              </div>

              <div v-if="info.status===4">
                <label for="status4" v-if="info.status===4">
                  <van-tag :type="info.status === 4 ? 'success' : '' " class="radio-tag">来访</van-tag>
                  <input type="radio" v-model="info.status" id="status4" value="4" style="display: none" />
                </label>
              </div>
            </div>
          </div>

          <div class="van-cell van-field van-hairline van-cell--required">
            <div class="van-cell__title">
              <span class="van-cell__text">{{ options.labels?options.labels.name:'' }}</span>
            </div>
            <div class="van-cell__value" style="text-align: left;">
              <div>
                <label :for="'labels'+item.key" v-for="item in options.labels?options.labels.list:[]" :key="item.key">
                  <van-tag :type="info.labels === item.key ? 'success' : '' "
                    class="radio-tag">{{ item.value }}</van-tag>
                  <input type="radio" v-model="info.labels" :id="'labels'+item.key" :value="item.key"
                    style="display: none" />
                </label>
              </div>
            </div>
          </div>
        </van-cell-group>

        <van-row gutter="2">
          <van-col span="12"><van-button size="large" class="pop_button" @click="onClickRight">保存</van-button></van-col>

          <van-col span="12">
            <van-button size="large" type="primary" class="pop_button" @click="showMore">点击添加更多信息</van-button>
          </van-col>
        </van-row>
      </div>
      <!--跟进信息-->

      <!--跟进日志-->
      <div style="margin-top: 10px;">
        <h2 class="van-doc-demo-block__title">跟进日志</h2>
        <van-cell-group v-if="isMy">
          <div class="van-panel__header van-hairline--bottom" v-for="item in logs" :key="item.id"
            @click="onClickLog(item.id)">
            <div class="van-panel__title">{{ item.employee_text }}</div>
            <span class="van-panel__desc">
              <van-row v-if="item.subject_text">
                <van-col span="24">
                  <van-tag type="success" v-if="item.subject_text">{{ item.subject_text }}</van-tag>
                </van-col>
              </van-row>
              <van-row v-if="item.come_time">
                <van-col span="24">来访时间: {{ item.come_time }}</van-col>
              </van-row>
              <van-row>
                <van-col span="24">跟进信息: {{ item.content }}</van-col>
              </van-row>
            </span>
            <span class="van-panel__log" style="margin-top: 5px;">
              <van-tag type="success" v-if="item.best">最佳</van-tag>
              <van-tag :style="item.type_color">{{ item.type_text }}</van-tag>
              <span style="margin-left: 10px;">{{ item.created_at }}</span>
            </span>
          </div>
        </van-cell-group>
      </div>
      <!--跟进日志-->
    </div>
    <!--跟进主界面结束-->

    <!--扩展界面开始-->
    <div>
      <van-popup v-model="showMorePop" position="right" style="width:100%;height: 100%;overflow: auto">
        <div>
          <van-nav-bar title="客户扩展信息" left-text="返回" left-arrow @click-left="onClickPopLeft" fixed />
        </div>
        <!--扩展信息-->
        <div style="margin-top: 45px;">
          <!--微信信息-->
          <h2 class="van-doc-demo-block__title">微信信息</h2>
          <van-cell-group>
            <van-field v-model="info.wechat" label="微信号" icon="clear" placeholder="请输入客户微信昵称"
              @click-icon="info.wechat = ''" />
            <van-field v-model="info.wechat_nickname" label="微信昵称" icon="clear" placeholder="请输入客户微信昵称"
              @click-icon="info.wechat_nickname = ''" />
          </van-cell-group>
          <!--微信信息-->

          <!--意向相关信息-->
          <h2 class="van-doc-demo-block__title">意向相关信息</h2>
          <van-cell-group>
            <van-field v-model="info.region_text" placeholder="请选择" :label="options.region?options.region.name:''"
              v-on:focus="showSelete('region')" />
            <van-field v-model="info.area_text" placeholder="请选择" :label="options.area?options.area.name:''"
              v-on:focus="showSelete('area')" />
            <van-field v-model="info.type_text" placeholder="请选择" :label="options.type?options.type.name:''"
              v-on:focus="showSelete('type')" />
            <van-field v-model="info.total_text" placeholder="请选择" :label="options.total?options.total.name:''"
              v-on:focus="showSelete('total')" />
            <van-field v-model="info.price_text" placeholder="请选择" :label="options.price?options.price.name:''"
              v-on:focus="showSelete('price')" />
          </van-cell-group>
          <!--意向相关信息-->

          <!--其他信息-->
          <van-cell-group>
            <h2 class="van-doc-demo-block__title">其他信息</h2>
            <van-field v-model="info.buy_type_text" placeholder="请选择" :label="options.buy_type?options.buy_type.name:''"
              v-on:focus="showSelete('buy_type')" />
            <van-field v-model="info.income_text" placeholder="请选择" :label="options.income?options.income.name:''"
              v-on:focus="showSelete('income')" />
            <van-field v-model="info.manager_text" placeholder="请选择" :label="options.manager?options.manager.name:''"
              v-on:focus="showSelete('manager')" />
            <van-field v-model="info.industry_text" placeholder="请选择" :label="options.industry?options.industry.name:''"
              v-on:focus="showSelete('industry')" />
            <van-field v-model="info.job_time_text" placeholder="请选择" :label="options.job_time?options.job_time.name:''"
              v-on:focus="showSelete('job_time')" />
            <van-field v-model="info.job_text" placeholder="请选择" :label="options.job?options.job.name:''"
              v-on:focus="showSelete('job')" />
            <van-field v-model="info.buy_house_text" placeholder="请选择"
              :label="options.buy_house?options.buy_house.name:''" v-on:focus="showSelete('buy_house')" />
            <van-field v-model="info.financial_text" placeholder="请选择"
              :label="options.financial?options.financial.name:''" v-on:focus="showSelete('financial')" />
            <van-field v-model="info.introduce_text" placeholder="请选择"
              :label="options.introduce?options.introduce.name:''" v-on:focus="showSelete('introduce')" />
          </van-cell-group>
          <!--其他信息-->
        </div>

        <van-button size="large" type="primary" class="pop_button" @click="closeMore">点击关闭更多信息</van-button>
        <!--扩展信息-->
      </van-popup>
    </div>
    <!--扩展界面结束-->

    <calendar v-model="showLogTimePop" :minDate="minDate" :maxDate="maxDate" :defaultDate="currentDate"
      @change="setLogTime"></calendar>

    <calendar v-model="showComeTimePop" :minDate="minDate" :maxDate="maxDate" :defaultDate="currentDate"
      @change="setComeTime"></calendar>

    <van-popup v-model="showSelectPop" position="bottom" :lock-scroll="false">
      <van-picker show-toolbar :title="title" :columns="columns" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>

    <van-dialog v-model="show" show-cancel-button :before-close="beforeClose">
      <div class="van-dialog__header">提示</div>
      <div class="van-dialog__content van-hairline">
        <div class="van-dialog__message van-dialog__message--withtitle" style="text-align: center">是否确定提交跟进记录?</div>
      </div>
    </van-dialog>
    <van-popup v-model="showSubjectPop" position="bottom" :overlay="true">
      <vue-pickers :show="showSubjectPop" :selectData="pickSubjectData" v-on:cancel="closeSubject"
        v-on:confirm="confirmSubject"></vue-pickers>
    </van-popup>

    <van-popup v-model="showSubjectArrayPop" position="bottom" :overlay="true" class="van-popup--bottom">
      <section class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">{{ options.subject?options.subject.name:'' }}</h2>
        <div style="margin-left: 10px;margin-right: 5px;">
          <label :for="'subjects'+item.value" v-for="item in options.subject?options.subject.list:[]" :key="item.value">
            <van-tag :type="checkSubjects.indexOf(item.value) !== -1 ? 'primary' : '' "
              class="checkbox-tag">{{ item.text }}</van-tag>
            <input type="checkbox" v-model="checkSubjects" :id="'subjects'+item.value" :value="item.value"
              style="display: none" />
          </label>
        </div>
      </section>
    </van-popup>

  </div>
</template>

<script>
  import VuePickers from 'vue-pickers'
  export default {
    components: {
      VuePickers
    },
    data() {
      return {
        id: 0,
        index: "",
        title: "请选择",
        isMy: true,
        isSubmit: true,

        info: [],
        log_time: "",
        log_content: "",

        logs: [],
        come: [],
        successes: [],
        subjects: [],


        options: [],
        columns: [],
        columnsName: '',
        show: false,
        showStatusPop: false,
        showLogTimePop: false,
        showComeTimePop: false,
        showMorePop: false,
        showSelectPop: false,
        showSubjectArrayPop: false,

        checkSubjects: [],

        minDate: new Date(),
        maxDate: new Date(),
        currentDate: new Date(),

        showSubjectPop: false,
        pickSubjectData: {
          columns: 1, // picker的列数
          // 第一列的数据结构
          pData1: []
        }
      };
    },
    watch: {
      checkSubjects: function(val) {
        this.info.subjects_text = ""
        if (this.checkSubjects.length > 0) {
          this.info.subjects_text = "已有选择的意向项目"
        }
        this.info.subjects = this.checkSubjects;
      },
    },
    methods: {
      onClickLog(id) {
        this.$dialog.confirm({
          title: '提示',
          message: '是否确定设置次跟进为最佳跟进？'
        }).then(() => {
          this.$api.post('/api/customer/set-best', {
            id: id
          }, r => {
            let list = this.logs;
            list.forEach(function(val, index, arr) {
              this.logs[index].best = false
              if (val.id == id) {
                this.logs[index].best = true
              }
            }, this)
          })
        }).catch(() => {
          // on cancel
        });
      },
      setPhone() {
        window.location.href = 'tel://' + this.info.mobile;
      },
      setMsn() {
        window.location.href = 'sms://' + this.info.mobile;
      },
      beforeClose(action, done) {
        if (action === 'confirm') {
          this.info.log_time = this.log_time;
          this.info.log_content = this.log_content;
          let arr = this.info
          let obj = {}
          for (let key in arr) {
            obj[key] = arr[key]
          }
          this.$api.post('/api/customer/edit', {
            customer: obj
          }, r => {
            this.$toast('客户跟进成功')
            if (this.$route.params.from === 'remind') {
              this.$router.push('/remind');
            } else {
              if (this.$route.params.from === 'random') {
                this.$router.push('/customer');
              }
              this.info = r.info
              let cusList = this.$store.state.customer.state.list
              cusList.forEach(function(val, index, arr) {
                if (val.id == this.id) {
                  this.index = index
                  this.$store.state.customer.state.list[index].name = this.info.name
                  this.$store.state.customer.state.list[index].labels_text = this.info.labels_text
                  this.$store.state.customer.state.list[index].status_text = this.info.status_text
                  this.$store.state.customer.state.list[index].log_content = this.info.log_content
                  this.$store.state.customer.state.list[index].log_time = this.info.log_time
                  this.$store.state.customer.state.list[index].is_edit = true
                  this.$router.push('/customer');
                }
              }, this)
            }
          })
          setTimeout(done, 2000);
        } else {
          done();
        }
      },
      onClickLeft() {
        this.$router.back(-1);
      },
      onClickRight() {
        if (!this.log_content) {
          this.$dialog.alert({
            message: '请填写跟进信息'
          });
          return
        }

        if (!this.info.status || this.info.status === -2) {
          this.$dialog.alert({
            message: '请选择客户状态'
          });
          return
        }

        if (!this.info.keyword) {
          this.$dialog.alert({
            message: '请填写关键词'
          });
          return
        }

        if (!this.info.labels) {
          this.$dialog.alert({
            message: '请选择客户等级'
          });
          return
        }

        if (!this.info.subject_id) {
          this.$dialog.alert({
            message: '请选择主推产品'
          });
          return
        }

        this.show = true
      },
      showSubjectArray() {
        document.activeElement.blur();
        this.showSubjectArrayPop = true
      },
      showSubject() {
        document.activeElement.blur();
        this.showSubjectPop = true
      },
      closeSubject() {
        this.showSubjectPop = false
      },
      confirmSubject(data) {
        this.info.subject_text = data.select1.text
        this.info.subject_id = data.select1.value
        this.showSubjectPop = false
      },
      showComeTime() {
        document.activeElement.blur();
        this.showComeTimePop = true
      },
      setComeTime(date, formatDate) {
        document.activeElement.blur();
        this.info.come_time = formatDate
        this.showComeTimePop = false
      },
      cancelComeTime() {
        this.info.come_time = ""
        this.showLogTimePop = true
        this.showLogTimePop = false
      },
      showLogTime() {
        document.activeElement.blur();
        this.showLogTimePop = true
      },
      setLogTime(date, formatDate) {
        document.activeElement.blur();
        this.log_time = formatDate
        this.showLogTimePop = false
      },
      showMore() {
        this.showMorePop = true
      },
      closeMore() {
        this.showMorePop = false
      },
      onClickPopLeft() {
        this.showMorePop = false
      },
      onConfirm(value, index) {
        switch (this.columnsName) {
          case 'region':
            this.info.region = index
            this.info.region_text = value
            break;
          case 'area':
            this.info.area = index
            this.info.area_text = value
            break;
          case 'type':
            this.info.type = index
            this.info.type_text = value
            break;
          case 'price':
            this.info.price = index
            this.info.price_text = value
            break;
          case 'total':
            this.info.total = index
            this.info.total_text = value
            break;
          case 'buy_type':
            this.info.buy_type = index
            this.info.buy_type_text = value
            break;
          case 'income':
            this.info.income = index
            this.info.income_text = value
            break;
          case 'manager':
            this.info.manager = index
            this.info.manager_text = value
            break;
          case 'industry':
            this.info.industry = index
            this.info.industry_text = value
            break;
          case 'job_time':
            this.info.job_time = index
            this.info.job_time_text = value
            break;
          case 'job':
            this.info.job = index
            this.info.job_text = value
            break;
          case 'buy_house':
            this.info.buy_house = index
            this.info.buy_house_text = value
            break;
          case 'financial':
            this.info.financial = index
            this.info.financial_text = value
            break;
          case 'introduce':
            this.info.introduce = index
            this.info.introduce_text = value
            break;
          case 'channel':
            this.info.channel = index
            this.info.channel_text = value
            break;
          case 'subject':
            this.info.subject_id = index
            this.info.subject_text = value
            break;
        }
        this.showSelectPop = false
      },
      onCancel() {
        this.showLogTimePop = false
        this.showSelectPop = false
      },
      showSelete($key) {
        document.activeElement.blur();
        this.columnsName = $key
        let optionsList = this.options
        Object.keys(optionsList).forEach(function(key) {
          if (key == this.columnsName) {
            this.columns = optionsList[key].list
          }
        }, this);
        this.showSelectPop = true
      }
    },
    created: function() {
      if (this.$route.params.from === 'random') {
        this.isMy = false
      }
      let now = new Date();
      now.setDate(now.getDate() + 20);
      this.maxDate = now
      window.scroll(0, 0)
      if (this.$store.state.customer.state.options.status) {
        this.options = this.$store.state.customer.state.options
        this.pickSubjectData.pData1 = this.options.subject.list
      } else {
        //获取下拉条件
        this.$api.post('/api/base/options', null,
          r => {
            this.$store.state.customer.state.options = r.data
            this.options = r.data
            this.pickSubjectData.pData1 = this.options.subject.list
          }
        )
      }

      //获取客户信息
      this.id = this.$route.params.id
      this.$store.state.customer.state.detail = []
      this.$api.post('/api/customer/detail', {
        id: this.id,
      }, cus => {
        this.$store.state.customer.state.detail = cus
        this.info = this.$store.state.customer.state.detail.info
        this.logs = this.$store.state.customer.state.detail.logs
        this.subjects = this.$store.state.customer.state.detail.subjects
        this.come = this.$store.state.customer.state.detail.come
        this.successes = this.$store.state.customer.state.detail.successes
        let subjectArray = this.subjects
        subjectArray.forEach(function(val, index, arr) {
          this.checkSubjects.push(val.id)
        }, this)
      })
    }
  }
</script>

<style scoped>
  .van-field .van-cell__title {
    min-width: 80px;
  }

  .pop_button {
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .radio-tag {
    min-width: 35px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    margin-bottom: 5px;
  }

  @media screen and (max-width:350px) {

    /*宽度小于等于350*/
    .radio-tag {
      min-width: 25px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      margin-bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/edit.vue